
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91404_93e_A6eT2qbeN8ceq0DJV0zVQebag80Ldqz7y_fnoBTeAMeta } from "/app/pages/[404].vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indexsziV31bRWzCkX_45YudaBOdqrwcbympIP9GPi2Nu0StJUMeta } from "/app/pages/about/index.vue?macro=true";
import { default as indexgIHaC0fdW2BGHm1KPXppFjW1YknpFdYO_LTaS3pYtQQMeta } from "/app/pages/terms/index.vue?macro=true";
import { default as indexQYLsx_45Y4jATQ8DXrAIU_45u9flcnkF2hfIzb8JBUok5iMMeta } from "/app/pages/credits/index.vue?macro=true";
import { default as indexdE_UA8oF0KJtAE6KiO0P6I6VgyACLCuQoDBZhO0l_gcMeta } from "/app/pages/explore/index.vue?macro=true";
import { default as index80yQPjX__45OAZHC9Ixgmo_O5cgLuggawhZDjo3npIqFkMeta } from "/app/pages/partnership/index.vue?macro=true";
import { default as _91propertyId_93KuSx5Pe0FOF_45LANPQ4ENmrL4iLSlmzz_gUV6r4_45hr7EMeta } from "/app/pages/embed/[propertyId].vue?macro=true";
import { default as _91propertyId_93kS8LLBbdiFz9GTsSr8gExMY48442qSPEXycokx1rnlYMeta } from "/app/pages/place/[propertyId].vue?macro=true";
import { default as indexAWLVNp8iMHF70fkcB3DYOBON8T44sZWE_fzwjUZuNjkMeta } from "/app/pages/privacy-policy/index.vue?macro=true";
import { default as _91propertyId_93JQo4VAnbwaXP4_45iiVjQVKHjIa0jUPF75YqWOpEnLvCoMeta } from "/app/pages/embed/do/[propertyId].vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "404",
    path: "/:404()",
    component: () => import("/app/pages/[404].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/app/pages/about/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/app/pages/terms/index.vue")
  },
  {
    name: "credits",
    path: "/credits",
    component: () => import("/app/pages/credits/index.vue")
  },
  {
    name: "explore",
    path: "/explore",
    component: () => import("/app/pages/explore/index.vue")
  },
  {
    name: "partnership",
    path: "/partnership",
    component: () => import("/app/pages/partnership/index.vue")
  },
  {
    name: "embed-propertyId",
    path: "/embed/:propertyId()",
    meta: _91propertyId_93KuSx5Pe0FOF_45LANPQ4ENmrL4iLSlmzz_gUV6r4_45hr7EMeta || {},
    component: () => import("/app/pages/embed/[propertyId].vue")
  },
  {
    name: "place-propertyId",
    path: "/place/:propertyId()",
    meta: _91propertyId_93kS8LLBbdiFz9GTsSr8gExMY48442qSPEXycokx1rnlYMeta || {},
    component: () => import("/app/pages/place/[propertyId].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/app/pages/privacy-policy/index.vue")
  },
  {
    name: "embed-do-propertyId",
    path: "/embed/do/:propertyId()",
    meta: _91propertyId_93JQo4VAnbwaXP4_45iiVjQVKHjIa0jUPF75YqWOpEnLvCoMeta || {},
    component: () => import("/app/pages/embed/do/[propertyId].vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/view/:pathMatch(.*)",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]